export const UserRole = {
    Admin: 'Admin',
    Manager: 'Manager',
    Supervisor: 'Supervisor',
    Worker: 'Worker',
};
export const WorkerStatus = {
    available: 'available',
    deployed: 'deployed',
    unavailable: 'unavailable',
    dnu: 'dnu',
};
export const RtwStatus = {
    uk: 'uk',
    iltr: 'iltr',
    visa: 'visa',
};
export const CertStatusValue = {
    valid: 'valid',
    expiring: 'expiring',
    expired: 'expired',
};
export const WorkerCertSummary = {
    ok: 'ok',
    warn: 'warn',
    alert: 'alert',
};
export const ProjectStatus = {
    live: 'live',
    upcoming: 'upcoming',
    completed: 'completed',
    cancelled: 'cancelled',
    paused: 'paused',
};
export const DeploymentStatus = {
    active: 'active',
    completed: 'completed',
    cancelled: 'cancelled',
    sick: 'sick',
    holiday: 'holiday',
};
export const ArrivalStatus = {
    pending: 'pending',
    confirmed: 'confirmed',
    dna: 'dna',
};
export const VacancyStatus = {
    open: 'open',
    filled: 'filled',
};
export const ContactType = {
    Customer: 'Customer',
    Worker: 'Worker',
    Supplier: 'Supplier',
    Contractor: 'Contractor',
    Consultant: 'Consultant',
    Internal: 'Internal',
    Other: 'Other',
};
export const CustomerType = {
    Developer: 'Developer',
    MainContractor: 'MainContractor',
    LocalAuthority: 'LocalAuthority',
    HousingAssociation: 'HousingAssociation',
    Private: 'Private',
    Retailer: 'Retailer',
    PublicSector: 'PublicSector',
    Other: 'Other',
};
export const SupplierCompliance = {
    compliant: 'compliant',
    pending: 'pending',
    nonCompliant: 'non-compliant',
};
export const SignInType = {
    in: 'in',
    out: 'out',
};
export const BroadcastChannel = {
    wa: 'wa',
    sms: 'sms',
    email: 'email',
};
export const ProjectDocumentType = {
    Drawings: 'Drawings',
    MethodStatement: 'Method Statement',
    RiskAssessment: 'Risk Assessment',
    Programme: 'Programme',
    Contract: 'Contract',
    HSPlan: 'H&S Plan',
    Insurance: 'Insurance',
    Correspondence: 'Correspondence',
    Photo: 'Photo',
    Other: 'Other',
};
export const SignatureRecipientStatus = {
    pending: 'pending',
    signed: 'signed',
    declined: 'declined',
};
export const AuditAction = {
    create: 'create',
    update: 'update',
    delete: 'delete',
    view_sensitive: 'view_sensitive',
    login: 'login',
    logout: 'logout',
    grant_access: 'grant_access',
    revoke_access: 'revoke_access',
    export: 'export',
};
//# sourceMappingURL=enums.js.map